import { createContext, useContext, useEffect, useState } from "react";

export const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [nextRoute, setNextRoute] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const confirmNavigation = (callback) => {
    setHasUnsavedChanges(false);
    setShowConfirmModal(false);
    callback();
  };
  return (
    <UnsavedChangesContext.Provider
      value={{
        hasUnsavedChanges,
        setHasUnsavedChanges,
        nextRoute,
        setNextRoute,
        showConfirmModal,
        setShowConfirmModal,
        confirmNavigation,
      }}
    >
      {children}
    </UnsavedChangesContext.Provider>
  );
};

export const useUnsavedChanges = () => useContext(UnsavedChangesContext);
